
<div class="pg-index stop-swiping" :class="star" ref="index">
  <div class="pg-header"></div>
  <!-- <div class="pg-bottom"></div> -->
  <div class="main-swiper swiper-container">
    <div class="swiper-wrapper" ref="wrapper">
      <!-- p1 -->
      <div class="swiper-slide p1" ref="p1">
        <!-- <div class="logo"></div> -->
        <div class="btn-wrap" :class="star">
          <div class="times">剩余抽奖次数:<span class="emphsis">{{chance}}</span></div>
          <div class="draw" :class="star" @click="lotto"></div>
        </div>
        <div class="btn-wrap btn-wrap-2">
          <div class="times times-call">召集<span class="emphsis">1位</span>兄弟,增加<span class="emphsis">1次</span>抽奖机会</div>
          <div class="call" :class="star" @click="callFriend"></div>
          <!-- <div class="call-times">还可以召集{{userInfo.weixin_state ? userInfo.invitablenum : 4}}名兄弟</div> -->
        </div>
        <div class="lucky" :class="star">
          <autoScroll :list.sync="luckyList" :config="config">
            <template v-slot="vData">
              <!-- 数据渲染列表 -->
              <li v-for="(item, index) in vData.vDota" :key="index" class="iztVnode-item" :style="{ height: vData.config.itemHeight + 'px',lineHeight: vData.config.itemHeight + 'px' }">
                <span class="lucky-name">{{item.nickname}}</span>&nbsp;&nbsp;已抽到&nbsp;&nbsp;<span class="lucky-prize">{{item.item_name}}</span>
              </li>
            <!-- 数据渲染列表 -->
            </template>
          </autoScroll>
        </div>

        <div class="frame" :class="star">
          <div class="frame-bg" :class="star">
            <div class="icon" @click="showDesc()"></div>
            <div class="frame-title" :class="star"></div>
            <div class="prize-wrapper swiper-container prize-swiper" :class="star">
              <div class="swiper-wrapper">
                <div class="swiper-slide frame-slide"  v-for="(item, index) in prize" :key="index">
                  <Prize v-for="(prize, pIndex) in item" :key="pIndex" :prize="prize.icon" :name="prize.name"></Prize>
                </div>
              </div>
            </div>
            <div class="swiper-pagination prize-pagination" :class="star">
            </div>
          </div>
          <div class="wx" @click="showWx()"></div>
        </div>

        <div class="slide-prev" @click="slidePrev"></div>
        <div class="slide-prev next" @click="slideNext"></div>

      </div>
      <!-- p2 -->
      <div class="swiper-slide p2" ref="p2">
        <div
          class="get"
          :class="[star, (!prizeList.list || prizeList.list.some(x => x.state) && userInfo.charname || !candraw) ? 'disabled' : '']"
          @click="getPrize"
        ></div>
        <div class="bind" :class="[star,userInfo.isbind || !candraw ? 'disabled' : '']" @click="bindRole"></div>
        <div v-if="userInfo.isbind" class="role" :class="star">
          <span class="role-title">已绑定角色：</span>
          <span class="role-name">{{userInfo.charname}}</span>
        </div>
        <Frame
          class="big-frame"
          :class="star"
          :height="((star === 'gaoye' || star === 'lv') && (prizeHeight + 32) < 500 ? 500 : (prizeHeight + 32))/100 + 'rem'"
        >
          <div v-if="!prizeList.list || !prizeList.list.length" class="none">暂无奖励</div>
          <div v-else class="desc">点击图标，<span style="color: #c21000">选择10种</span>想要领取的奖励</div>
          <div v-if="prizeList.realinfo" class="address" @click="handleAddress">填写地址</div>
          <div class="prize-wrapper" :class="star">
            <Prize
              v-for="(prize, index) in prizeList.list"
              :key="index"
              :prize="prize.icon"
              :name="prize.title"
              :drawed="prize.state"
              :id="prize.id"
              :choosed="myPrize.length ? myPrize.some(x => x.id === prize.id) : false"
              :can-draw="!prize.state && prizeList.list && !prizeList.list.some(x => x.state) && myPrize.length < 10"
              @toggle="togglePrize"
            >
            </Prize>
          </div>
        </Frame>
      </div>
    </div>
  </div>
  <div class="header">
    <div class="game_icon"></div>
    <div class="game_button fr">
      <a href="/download" class="bt-download"></a>
      <!-- <a href="" class="bt-download ios"></a> -->
      <a href="/index.shtml" class="home"></a>
    </div>
  </div>
  <a class="nav" href="/act/jnh2024/"></a>
  <div class="slogan slideInDown animated"></div>
  <div class="swiper-pagination main-pagination">
    <div
      class="swiper-pagination-bullet"
      :class="[
        `swiper-pagination-bullet-${index + 1}`,
        activeIndex === index ? 'active' : ''
      ]"
      v-for="(item, index) in bullets"
      :key="index"
      @click="slideTo(index)"
    >
    </div>
  </div>
</div>
